
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M144 30.1c-13 2.5-25.7 12.5-32 25.2l-4.1 8.2-26.7.5c-24.9.5-27.1.7-32.5 2.9-11.4 4.5-21.5 15.2-25.3 26.8-1.7 5.3-1.9 9.2-1.9 47.3 0 36.1.3 42.4 1.8 48.3 6.8 26.9 23.5 47.3 47.9 58.6 14.5 6.7 18.1 7.3 47.8 7.8l26.5.5 8.4 9c14.2 15.2 32.7 28.1 51.4 35.8l7.7 3.3v65.6l-26.7.3-26.8.3-6 2.9c-7.6 3.8-15.4 11.5-18.7 18.6-2.3 5-12.7 44.7-14.3 54.6-.8 5.4.8 14.2 3.9 21 5.2 11.4 17.2 20.3 30.1 22.4 8.1 1.3 194.9 1.3 203 0 12.9-2.1 24.9-11 30.1-22.5 2.9-6.3 4.6-15.5 3.8-20.5-1.4-9.5-12-50.2-14.2-55-3.3-7.1-11.1-14.8-18.7-18.6l-6-2.9-26.7-.3-26.8-.3v-65.6l8.9-3.8c18.1-7.6 36-20.2 50.2-35.4l8.4-8.9 26.5-.5c29.7-.5 33.3-1.1 47.8-7.8 27-12.5 45.5-37.7 49.1-66.9 1.4-10.9 1.4-72.5 0-80.9-2.7-17-14.8-30.2-31.4-34.6-4.5-1.1-11.6-1.5-30-1.5h-24.2l-4.1-8.4c-6.7-13.5-18.8-22.9-33.1-25.6-6.7-1.3-216.6-1.2-223.1.1m-34.6 82.1c.4 2.9 2 21.3 3.6 40.8 2.8 32.6 4.9 47.4 7.9 55.3.6 1.6 1.1 3.3 1.1 3.9s-4.6.9-13.2.6c-12.7-.3-13.6-.5-20.2-3.7-7.7-3.7-14.8-10.2-18.9-17.1-5.2-8.9-5.7-13.4-5.7-50.7V107h44.9zM448 141.3c0 37.3-.5 41.8-5.7 50.7-4.1 6.9-11.2 13.4-18.9 17.1-6.6 3.2-7.5 3.4-20.1 3.7-8.7.3-13.3 0-13.3-.6s.5-2.3 1.1-3.9c3-7.8 5.1-22.9 7.9-55.3 1.6-19.5 3.2-37.9 3.6-40.8l.5-5.2H448z"}})])
          )
        }
      }
    